<div class="form-group">
    <label class="control-label">{{label}}</label>
    <div class="input-group input-group-sm">
      <input type="text" class="form-control" [(ngModel)]="model" placeholder="{{label}}" (change)="change()" aria-describedby="gen-pwd-btn">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" id="gen-pwd-btn" (click)="generatePassword()">{{buttonLabel}}</button>
      </div>
    </div>
</div>